(function(){
'use strict';

/*
  BGC HORDS drawer utility persistence.
  Utility-actions owns the bar, styles, and button behavior.
  Normal plus/minus gets one narrowly scoped DOM-preservation attempt, mirroring
  the proven Purchase Options pattern. The observer disconnects BEFORE moving
  the saved bar and can move it only once. Trash/removal is intentionally not
  preserved here. The existing quiet-period recovery remains the safety net.
*/
if(window.__BGC_DRAWER_UTILITY_PERSISTENCE_2026__)return;
window.__BGC_DRAWER_UTILITY_PERSISTENCE_2026__=1;

var QUIET_MS=325;
var MAX_WATCH_MS=4500;
var QTY_PRESERVE_MS=1400;
var boundCart=null;
var observer=null;
var quietTimer=0;
var maxTimer=0;
var settleTimer=0;
var qtyObserver=null;
var qtyTimer=0;
var qtyBar=null;

function cartRoot(){
  return document.getElementById('cart');
}

function mountOnce(){
  var fn=window.__BGC_DRAWER_UTILITY_MOUNT_2026__;
  if(typeof fn==='function')fn();
}

function disconnectObserver(){
  if(observer){
    observer.disconnect();
    observer=null;
  }
}

function stopQtyPreserve(){
  if(qtyObserver){
    qtyObserver.disconnect();
    qtyObserver=null;
  }
  clearTimeout(qtyTimer);
  qtyTimer=0;
  qtyBar=null;
}

function quantityValue(control){
  var row=control&&control.closest?control.closest('li'):null;
  var input=row&&row.querySelector?row.querySelector('.updates'):null;
  if(!input)return null;
  var value=parseInt(input.value,10);
  return isNaN(value)?null:value;
}

function armQtyPreserve(control){
  stopQtyPreserve();
  if(!control||!window.MutationObserver)return;

  if(control.classList.contains('minus')){
    var value=quantityValue(control);
    if(value!==null&&value<=1)return;
  }

  var root=cartRoot();
  var saved=root&&root.querySelector('.bgc-drawer-utility-actions');
  if(!root||!saved)return;

  qtyBar=saved;
  qtyObserver=new MutationObserver(function(){
    var liveRoot=cartRoot();
    var moving=qtyBar;
    if(!liveRoot||!moving){
      stopQtyPreserve();
      return;
    }

    if(moving.isConnected&&liveRoot.contains(moving))return;

    var existing=liveRoot.querySelector('.bgc-drawer-utility-actions');
    if(existing&&existing!==moving){
      stopQtyPreserve();
      return;
    }

    var subtitle=liveRoot.querySelector('li.mm-subtitle');
    var list=subtitle&&subtitle.parentNode;
    if(!list||list.nodeType!==1)list=liveRoot.querySelector('ul');
    if(!list)return;

    /* One shot only: disconnect BEFORE reattaching the saved bar. */
    if(qtyObserver){
      qtyObserver.disconnect();
      qtyObserver=null;
    }
    clearTimeout(qtyTimer);
    qtyTimer=0;
    qtyBar=null;

    if(subtitle&&subtitle.parentNode===list){
      subtitle.insertAdjacentElement('afterend',moving);
    }else{
      list.insertBefore(moving,list.firstChild);
    }
  });
  qtyObserver.observe(root,{childList:true,subtree:true});
  qtyTimer=setTimeout(stopQtyPreserve,QTY_PRESERVE_MS);
}

function stopWatch(){
  clearTimeout(quietTimer);
  quietTimer=0;
  clearTimeout(maxTimer);
  maxTimer=0;
  clearTimeout(settleTimer);
  settleTimer=0;
  disconnectObserver();
}

function finishAfterQuiet(){
  clearTimeout(quietTimer);
  quietTimer=0;
  clearTimeout(maxTimer);
  maxTimer=0;

  /* Critical rule: stop observing before we touch the drawer. */
  disconnectObserver();

  clearTimeout(settleTimer);
  settleTimer=setTimeout(function(){
    settleTimer=0;
    mountOnce();
    bindMmenu();
  },0);
}

function scheduleQuietFinish(){
  clearTimeout(quietTimer);
  quietTimer=setTimeout(finishAfterQuiet,QUIET_MS);
}

function giveUpSafely(){
  /* Stability beats cosmetics if the drawer never becomes quiet. */
  clearTimeout(quietTimer);
  quietTimer=0;
  clearTimeout(maxTimer);
  maxTimer=0;
  disconnectObserver();
}

function startWatch(assumeSettling){
  stopWatch();

  var root=cartRoot();
  if(!root)return;

  if(window.MutationObserver){
    observer=new MutationObserver(function(mutations){
      var meaningful=false;
      for(var i=0;i<mutations.length;i+=1){
        if(mutations[i].type==='childList'){
          meaningful=true;
          break;
        }
      }
      if(meaningful)scheduleQuietFinish();
    });
    observer.observe(root,{childList:true,subtree:true});

    if(assumeSettling)scheduleQuietFinish();
    maxTimer=setTimeout(giveUpSafely,MAX_WATCH_MS);
    return;
  }

  quietTimer=setTimeout(finishAfterQuiet,QUIET_MS);
}

function bindMmenu(){
  if(!window.jQuery)return;
  var cart=cartRoot();
  if(!cart)return;
  if(boundCart===cart)return;

  if(boundCart){
    try{window.jQuery(boundCart).off('.bgcDrawerUtilityPersistence');}catch(e){}
  }
  boundCart=cart;

  var $cart=window.jQuery(cart);
  $cart.on('opening.mm.bgcDrawerUtilityPersistence',function(){
    stopQtyPreserve();
    stopWatch();
    mountOnce();
  });
  $cart.on('opened.mm.bgcDrawerUtilityPersistence',function(){
    startWatch(true);
  });
  $cart.on('closing.mm.bgcDrawerUtilityPersistence closed.mm.bgcDrawerUtilityPersistence',function(){
    stopQtyPreserve();
    stopWatch();
  });
}

function initialize(){
  bindMmenu();
  mountOnce();
}

document.addEventListener('click',function(event){
  var target=event.target;
  if(!target||!target.closest)return;

  var headerCart=target.closest('#trewq .nav.mobile_hidden .cart-button:not(.no-js-only), #trewq .nav.mobile_hidden a[href="#cart"].cart-button, .top-link-cart');
  if(headerCart&&event.isTrusted!==false){
    stopQtyPreserve();
    stopWatch();
    bindMmenu();
    mountOnce();
    return;
  }

  var quantityControl=target.closest('#cart .plus, #cart .minus');
  if(quantityControl&&!target.closest('.bgc-drawer-utility-actions')){
    armQtyPreserve(quantityControl);
  }

  var nativeControl=target.closest('#cart .plus, #cart .minus, #cart .trash-alt, #cart [class*="trash"], #cart [data-remove], #cart a[href*="change"], #cart a[href*="remove"]');
  if(nativeControl&&!target.closest('.bgc-drawer-utility-actions')){
    /* Safety net: Retina finishes first, then one quiet-period mount if needed. */
    startWatch(false);
  }
},true);

document.addEventListener('change',function(event){
  if(event.target&&event.target.matches&&event.target.matches('#cart .updates')){
    startWatch(false);
  }
},true);

document.addEventListener('cart:updated',function(){
  bindMmenu();
  startWatch(true);
},false);

window.addEventListener('pageshow',function(){
  stopQtyPreserve();
  stopWatch();
  bindMmenu();
  mountOnce();
});

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',initialize,{once:true});
}else{
  initialize();
}
})();